import React from "react";
import "./styles.scss";
import { VideoPlayer } from "components/videoplayer";
// import { CopyShareUrl } from "components/copyShareUrl";
import Scrollchor from "react-scrollchor";

class Question extends React.Component {
  componentDidMount() {
    if (this._back !== null) this._back.simulateClick();
  }

  componentDidUpdate() {
    if (this._back !== null) this._back.simulateClick();
  }

  render() {
    return (
      <>
        <header className="ui vertical very relaxed blue segment question">
          <div className="ui text container">
            <h1 className="ui image header">
              <div className="content">
                {
                  this.props.questions[this.props.match.params.questionId - 1]
                    .label
                }
              </div>
            </h1>
          </div>
        </header>

        <Scrollchor
          animate={{ duration: 500 }}
          ref={ref => (this._back = ref)}
          to={
            this.props.match.params.candidateId
              ? "candidat-" + this.props.match.params.candidateId
              : "main-content"
          }
          disableHistory
        />

        <div className="ui container">
          <div className="ui vertical segment">
            <div className="ui two column grid">
              <div
                className="link column"
                onClick={() => {
                  this.props.history.push("/");
                }}
              >
                <i className="chevron left icon" />
                <span className="ui mobile hidden">
                  Retour à la liste des candidats
                </span>
                <span className="ui mobile only">Candidats</span>
              </div>

              <div
                className="link column right aligned"
                onClick={() => {
                  this.props.history.push(
                    "/questions/" +
                      ((+this.props.match.params.questionId % 7) + 1)
                  );
                }}
              >
                <span className="ui mobile hidden">Question suivante</span>
                <span className="ui mobile only">Suivante</span>
                <i className="chevron right icon" />
              </div>
            </div>
            <div className="answers">
              {this.props.candidates.map((candidate, i) => (
                <div
                  key={"candidate-" + i}
                  className="ui raised segment stackable two column grid"
                  id={"candidat-" + (i + 1)}
                >
                  <div className="column">
                    <div
                      className="ui small header link"
                      onClick={() => {
                        this.props.history.push("/candidats/" + candidate.id);
                      }}
                    >
                      {candidate["prénom"]} {candidate.nom}
                    </div>
                    <div className="small details">{candidate.liste}</div>
                    <div>
                      <q>
                        {
                          candidate[
                            "Réponse " + this.props.match.params.questionId
                          ]
                        }
                      </q>
                    </div>
                    <div
                      className="ta sharing ui horizontal link list"
                      style={{
                        lineHeight: "1em",
                        display: "block",
                        marginTop: "20px"
                      }}
                    >
                      <a
                        className="share inverted share item"
                        href={
                          "https://twitter.com/intent/tweet?url=http://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/questions/" +
                          this.props.match.params.questionId +
                          "/candidat/" +
                          (i + 1) +
                          "&text=" +
                          this.props.questions[
                            this.props.match.params.questionId - 1
                          ].label +
                          " La réponse de " +
                          candidate["prénom"] +
                          " " +
                          candidate.nom +
                          "&via=tdgch&hashtags=questionsCandidatsGE"
                        }
                      >
                        <i className="ui twitter icon" />
                      </a>
                      <a
                        className="share inverted share item"
                        href={
                          "https://www.facebook.com/dialog/share?display=popup&app_id=222318267841285&href=http://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/questions/" +
                          this.props.match.params.questionId +
                          "/candidat/" +
                          (i + 1) +
                          "&redirect_uri=http://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/questions/" +
                          this.props.match.params.questionId +
                          "/candidat/" +
                          (i + 1)
                        }
                      >
                        <i className="ui facebook icon" />
                      </a>
                      <a
                        className="share inverted share item"
                        href={
                          "whatsapp://send?text=http://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/questions/" +
                          this.props.match.params.questionId +
                          "/candidat/" +
                          (i + 1) +
                          " " +
                          this.props.questions[
                            this.props.match.params.questionId - 1
                          ].label +
                          " La réponse de " +
                          candidate["prénom"] +
                          " " +
                          candidate.nom
                        }
                      >
                        <i className="ui whatsapp icon" />
                      </a>
                      <a
                        className="share inverted share item"
                        href={
                          "mailto:?subject=Des%20questions%20et%20des%20candidats&body=http://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/questions/" +
                          this.props.match.params.questionId +
                          "/candidat/" +
                          (i + 1) +
                          " " +
                          this.props.questions[
                            this.props.match.params.questionId - 1
                          ].label +
                          " La réponse de " +
                          candidate["prénom"] +
                          " " +
                          candidate.nom
                        }
                      >
                        <i className="ui mail icon" />
                      </a>
                    </div>
                    {/* <CopyShareUrl
                      url={
                        "https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve" +
                        this.props.location.pathname +
                        "#reponse-" +
                        (i + 1)
                      }
                      text="Partager la réponse"
                    /> */}
                  </div>
                  <div className="column">
                    <VideoPlayer
                      mp4Mobile={
                        "https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/videos/" +
                        candidate.id +
                        "-" +
                        this.props.match.params.questionId +
                        ".mp4"
                      }
                      mp4={
                        "https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/videos/" +
                        candidate.id +
                        "-" +
                        this.props.match.params.questionId +
                        ".mp4"
                      }
                      poster={
                        "https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/videos/" +
                        candidate.id +
                        "-" +
                        this.props.match.params.questionId +
                        ".jpg"
                      }
                      trackingID={
                        candidate.id +
                        " - " +
                        this.props.match.params.questionId
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="ui two column grid vertical segment">
            <div
              className="link column"
              onClick={() => {
                this.props.history.push("/");
              }}
            >
              <i className="chevron left icon" />
              <span className="ui mobile hidden">
                Retour à la liste des candidats
              </span>
              <span className="ui mobile only">Candidats</span>
            </div>
            <div
              className="link column right aligned"
              onClick={() => {
                this.props.history.push(
                  "/questions/" +
                    ((+this.props.match.params.questionId % 7) + 1)
                );
              }}
            >
              <span className="ui mobile hidden">Question suivante</span>
              <span className="ui mobile only">Suivante</span>
              <i className="chevron right icon" />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Question;
